import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Icon, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ReactComponent as StartStepLogo } from "../../assets/icons/Tutorial/start-step.svg";
import { ReactComponent as MediaMensal } from "../../assets/icons/Tutorial/media-mensal.svg";
import { ReactComponent as Conquistar } from "../../assets/icons/Tutorial/conquistar.svg";
import { ReactComponent as Alavancar } from "../../assets/icons/Tutorial/alavancar.svg";
import { ReactComponent as Trabalhar } from "../../assets/icons/Tutorial/trabalhar.svg";
import { ReactComponent as Ganho } from "../../assets/icons/Tutorial/ganho.svg";

function TutorialModal({
  content,
  setCurrentStep,
  transition,
  isHighlightingObserved,
  currentStep,
  setIsOpen,
}) {
  console.log(currentStep);
  const [footer, setFooter] = useState(null);
  const [header, setHeader] = useState(null);

  useEffect(() => {
    switch (currentStep) {
      case 0:
        setFooter(
          <Grid
            className="tutorial-footer"
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            rowGap={"8px"}
          >
            <Grid item>
              <Button
                className="start-button-1"
                variant="contained"
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setCurrentStep(currentStep + 1);
                  transition();
                }}
              >
                Quero ser guiado pelo tutorial
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="start-button-2"
                variant="text"
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setIsOpen(false);
                  transition();
                }}
              >
                Não tenho interesse
              </Button>
            </Grid>
          </Grid>
        );
        setHeader(null);
        break;
      case 10:
        setFooter(
          <Grid
            className="tutorial-footer"
            container
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"flex-end"}
          >
            <Grid item>
              <Button
                className="end-button"
                variant="contained"
                onClick={() => {
                  setIsOpen(false);
                  transition();
                }}
              >
                OK
              </Button>
            </Grid>
          </Grid>
        );
        setHeader(null);
        break;
      default:
        setFooter(
          <Grid
            className="tutorial-footer"
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"flex-end"}
          >
            <Grid item>
              <Button
                className="tutorial-button-back"
                variant="text"
                startIcon={<ArrowBackIcon />}
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setCurrentStep(currentStep - 1);
                  transition();
                }}
              >
                Anterior
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="tutorial-button-next"
                variant="contained"
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setCurrentStep(currentStep + 1);
                  transition();
                }}
              >
                {currentStep === 9 ? "Finalizar tutorial" : "Próximo"}
              </Button>
            </Grid>
          </Grid>
        );
        setHeader(
          <Grid
            className="tutorial-header"
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            sx={{
              maxWidth: "660px",
            }}
          >
            <Grid
              item
              container
              flexDirection={"column"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              rowGap={"8px"}
              xs={10}
            >
              <Grid item>
                <Box className="tutorial-title" component="span">
                  Tutorial DN
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"flex-end"}
              alignItems={"flex-start"}
              xs={2}
            >
              <IconButton
                className="tutorial-button-close"
                onClick={() => {
                  setIsOpen(false);
                  transition();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        );
        break;
    }
  }, [currentStep]);

  return (
    <Grid
      className="tutorialWrapper"
      container
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"flex-start"}
      style={{
        minWidth: "580px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* HEADER */}
      {header}

      {/* CONTENT */}
      {content}

      {/* FOOTER */}
      {footer}
    </Grid>
  );
}

export const steps = [
  {
    selector: ".tutorial-start-step",
    position: "center",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "100%",
          height: "100%",
          textAlign: "center",
        }}
        rowGap={"12px"}
      >
        <Grid item xs>
          <StartStepLogo
            sx={{
              fontSize: "205px",
            }}
          />
        </Grid>
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={"8px"}
        ></Grid>
        <Grid item xs>
          <Box className="step-title" component={"span"}>
            Seja bem vindo(a) ao tutorial DN !
          </Box>
        </Grid>
        <Grid
          item
          xs
          sx={{
            width: "510px",
          }}
        >
          <Box className="start-step-subtitle" component={"span"}>
            Neste guia abrangente, você será conduzido através dos principais
            passos para dominar a plataforma de análises mais poderosa do
            mercado. Prepare-se para explorar um universo de insights
            valiosos, possibilitando que você tome decisões estratégicas
            fundamentadas e alcance resultados excepcionais.
          </Box>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-second-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "650px",
          width: "100%",
          height: "100%",
          paddingTop: "25px"
        }}
        rowGap={"10px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"PDVs Cliente"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Numero de pontos de venda do cliente"}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"PDVs Mercado"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Pontos de venda disponiveis no mercado"}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"%Cl. vs Mer."}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Comparação pontos de venda cliente vs mercado"}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"Cdd. Mercado"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Cidades disponiveis no mercado"}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"Cdd. Cliente"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Cidades disponiveis do cliente"}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"%Cdd. vs Mer."}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Comparativo entre cidades disponiveis no mercado vs do cliente"}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#04477B",
                color: "#FFFFFF",
                padding: "10px",
                borderRadius: "15px"
              }}
              component={"span"}
            >
              {"TMmês/cliente"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Ticket médio por mês do cliente"}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-third-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Visualização dos segmentos dos pontos de venda"}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-fourth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Cidades"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Visualização dos segmentos das cidades"}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-fifth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Mapa"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Aqui você pode explorar os dados a nivel do Pais, Estado e Cidades."}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-ninth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"flex-start"}
        sx={{
          maxWidth: "480px",
          width: "100%",
          height: "100%",
        }}
      >
        <Grid item xs>
          <Box className="tutorial-step-content" component={"span"}>
            <span style={{ color: "#262626" }}>
              {
                "Filtros com métricas alteráveis/mescladas para melhor visualização, ranqueando aquilo que desejar."
              }
            </span>
            <span style={{ color: "#8B8B8B" }}>
              {"(clique nos seletores)"}
            </span>
          </Box>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-end-step",
    position: "center",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "100%",
          height: "100%",
          textAlign: "center",
        }}
        rowGap={"12px"}
      >
        <Grid item xs>
          <CheckCircleOutlineIcon
            sx={{
              color: "#4ED04B",
              fontSize: "150px",
            }}
          />
        </Grid>
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={"8px"}
        ></Grid>
        <Grid item xs>
          <Box className="step-title" component={"span"}>
            Tutorial concluído!
          </Box>
        </Grid>
        <Grid
          item
          xs
          sx={{
            width: "510px",
          }}
        >
          <Box className="end-step-subtitle" component={"span"}>
            Desejamos sucesso em suas empreitadas e que o simulador DN seja
            um instrumento poderoso para o seu crescimento profissional e
            financeiro.
          </Box>
        </Grid>
      </Grid>
    ),
  },
];

export default TutorialModal;
